import React, { useState, useEffect } from "react";
import Label from "../../../ui/Label/Label";
import Select from "../../../ui/Select/Select";
import SearchInput from "../../../ui/SearchInput/SearchInput.js";
import Switch from "../../../ui/Switch/Switch";
import withQs from "../../../utils/WithQs";
import useDebounce from "../../../hooks/useDebounce";
import { canPayoutTeaser, canFilterByDate } from "../../../utils/perm";

const dateCreateOptions = [
  { label: "За сегодня", value: "today" },
  { label: "За вчера", value: "yesterday" },
  { label: "За позавчера", value: "2days_before" },
  { label: "За все время", value: "" },
  { label: "Отключатся завтра", value: "stop_tomorrow" },
  // отключенные по сроку жизни
  { label: "Подошел срок", value: "stopped_by_ttl" }
];

const TeaserListHeader = ({
  fixed,
  opened,
  toggleOpen,
  cards,
  search,
  setSearch,
  payoutMode,
  setPayoutMode,
  cardsAllowed,
  permissions
}) => {
  const [searchTerm, setSearchTerm] = useState(search.search_term || "");
  const debouncedTerm = useDebounce(searchTerm, 300);

  useEffect(() => {
    setSearch({ search_term: debouncedTerm });
  }, [debouncedTerm]);

  const labelColor = fixed ? "violett" : "";

  const getDateCreate = () => {
    return search.date || "";
  };

  return (
    <div className="header">
      <div className="header__content content-body">
        {cards.map(card => (
          <Label key={card.id} color={labelColor}>
            {card.name}
          </Label>
        ))}

        {cardsAllowed && (
          <div className="header__cards-toggle" onClick={toggleOpen}>
            {opened ? "Скрыть задачи" : "Показать задачи"}
          </div>
        )}

        <div className="header__controls-right">
          {fixed && canPayoutTeaser(permissions) && (
            <Switch
              label="Режим проверки"
              theme={fixed ? "dark" : ""}
              checked={payoutMode}
              onChange={setPayoutMode}
            />
          )}
          <Select
            options={dateCreateOptions}
            theme={fixed ? "dark" : ""}
            value={getDateCreate()}
            onSelect={e => setSearch({ date: e.value })}
            disabled={!canFilterByDate(permissions)}
          />
          <SearchInput
            placeholder="Название или [id]"
            theme={fixed ? "dark" : ""}
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
          />
        </div>
      </div>
    </div>
  );
};

TeaserListHeader.defaultProps = {
  permissions: []
};

export default TeaserListHeader;
